import React, { useMemo } from 'react';
import { EntityAboutCard } from '@backstage/plugin-catalog';
import { useEntity, EntityProvider } from '@backstage/plugin-catalog-react';

export const CustomEntityAboutCard = (props: any) => {
  const { entity } = useEntity();

  const enhancedEntity = useMemo(() => {
    // Si no tiene source-location pero tiene github.com/project-slug, agregarlo
    if (
      !entity.metadata.annotations?.['backstage.io/source-location'] &&
      entity.metadata.annotations?.['github.com/project-slug']
    ) {
      const projectSlug =
        entity.metadata.annotations['github.com/project-slug'];
      return {
        ...entity,
        metadata: {
          ...entity.metadata,
          annotations: {
            ...entity.metadata.annotations,
            'backstage.io/source-location': `url:https://github.com/${projectSlug}/tree/main/`,
          },
        },
      };
    }
    return entity;
  }, [entity]);

  return (
    <EntityProvider entity={enhancedEntity}>
      <EntityAboutCard {...props} />
    </EntityProvider>
  );
};
